module.exports = __webpack_public_path__ + "img/bot.982b2c49.png";